import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import InvestmentCalculator from './pages/InvestmentCalculator';
import RetirementCalculator from './pages/RetirementCalculator';
import RothIRACalculator from './pages/RothIRACalculator';
import Four01kCalculator from './pages/401kCalculator';
import InflationCalculator from './pages/InflationCalculator';
import DividendCalculator from './pages/DividendCalculator';

function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      <Navigation />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Routes>
          <Route path="/" element={<InvestmentCalculator />} />
          <Route path="/retirement" element={<RetirementCalculator />} />
          <Route path="/401k" element={<Four01kCalculator />} />
          <Route path="/roth-ira" element={<RothIRACalculator />} />
          <Route path="/inflation" element={<InflationCalculator />} />
          <Route path="/dividend" element={<DividendCalculator />} />
          {/* Catch all route - redirect to home for unknown routes */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;